import Vue from 'vue'
import Router from 'vue-router'
import childRouter from './routers'
const layout = (resolve) =>{require(['components/layout'], resolve)}; 

Vue.use(Router)

function getAbsolutePath () {
  let path = location.pathname
  return path.substring(0, path.lastIndexOf('/') + 1)
 }

export default new Router({
  mode: 'hash',
  base: getAbsolutePath(),
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      children:childRouter
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js